export default function (state, value) {
    for (let k in value) {
        if (typeof state[k] !== 'undefined') state[k] = value[k];
    }
}